module.exports = __webpack_public_path__ + "img/DE03149.dc0f6e77.png";